import { render } from "./HeroFooterHeader.vue?vue&type=template&id=5c60c9d6"
import script from "./HeroFooterHeader.vue?vue&type=script&lang=js"
export * from "./HeroFooterHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__